import Banner from './Banner';
import OurArticles from './OurArticles';
import Process from './Process';
import Reasons from './Reasons';
import SideNav from './SideNav';
import AwwwardsSlider from './AwwwardsSlider';

export { SideNav, AwwwardsSlider, Banner, OurArticles, Process, Reasons };
